/*
 * Project: forca
 * File Created: Tuesday, 19th October 2021 1:47:49 pm
 * Author: Teodor Moquist (teodor@moquist.dk)
 */

import React, { Component } from 'react';

import { OptionButtonsComponentProps, Option, OptionButtonsComponentState } from './optionButtons.definition';
import { SVGIcon } from '../../../img/svg-icons';

class OptionButtonsComponent extends Component<OptionButtonsComponentProps, OptionButtonsComponentState> {
	state: OptionButtonsComponentState = {
		selectedOption: null
	};

	renderOption(option: Option, i: number, selectedOption: number) {
		const { icon, svgIcon, title, content } = option;
		const isSelected = selectedOption === i;

		return (
			<button key={ i } className={ `OptionButtons-Option ${ isSelected ? 'OptionButtons-Option--isSelected' : '' }` } type="button" onClick={ () => this.setState({ selectedOption: i + 1 }) }>
				<div className={ `OptionButtons-${svgIcon ? 'SVG' : ''}Icon` }>
					{ icon && !svgIcon && (
						<i className={ `icon ${icon}` } />
					) }
					{ svgIcon && <SVGIcon name={ svgIcon } /> }
				</div>

				<h3 className="OptionButtons-Title" dangerouslySetInnerHTML={ { __html: title } } />
				{ content && (
					<div className="OptionButtons-Text" dangerouslySetInnerHTML={ { __html: content } } />
				) }
			</button>
		);
	}

	render() {
		const { selectedOption } = this.state;
		const {
			options = [],
			button
		} = this.props;

		return (
			<>
				<div className="OptionButtons-Content">
					{ options.map((option, i) => this.renderOption(option, i, selectedOption)) }
				</div>
				<div className="text-center">
					<a
						className={ `square-button button-type-3 ${ !selectedOption ? 'disabled' : '' }` }
						href={ options[selectedOption]?.link }
					>
						{ button }
					</a>
				</div>
			</>
		);
	}
}

export default OptionButtonsComponent;